// removed by extract-text-webpack-plugin
module.exports = {"container":"scoreboard__container___1HgD5","board":"scoreboard__board___9N-rw","dartboardSVG":"scoreboard__dartboardSVG___1F5iy","targetID":"scoreboard__targetID___iMAQj"};


//////////////////
// WEBPACK FOOTER
// ./containers/Scoreboard/scoreboard.css
// module id = 279
// module chunks = 0